import 'reflect-metadata'
import { injectable } from 'inversify'
import { DadosDeVendaServiceAdapter } from '@/usecases'
import { DadosDeVendaProcessada } from '@/models'
import { dadosDeVendas } from '@/api/dados-vendas'

@injectable()
export class DadosDeVendasService implements DadosDeVendaServiceAdapter {
	find = async (params: any, config?: any): Promise<DadosDeVendaProcessada[]> => await dadosDeVendas(params, config)
}
